<template>
  <div class="content--sinoreg Relatorios">
    <div>
      <header-blue>
        <h4 class="pl-2">
          Relatórios: Serviços Realizados e Recolhimento
        </h4>
      </header-blue>
    </div>
    <div class="row mt-1">
      <div class="col-7 m-1 ml-3 mt-3">
        <div class="row">
          <div class="col">
            <label class="label">Período:</label>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <input v-model="busca.data_inicial"
                   v-validate="`required`"
                   type="date"
                   name="data_inicial"
                   :class="{ 'is-invalid': errors.has('data_inicial') }"
                   class="form-control form-control-sm">
            <small v-if="errors.has('data_inicial')"
                   class="text-danger">{{ errors.first('data_inicial') }}</small>
          </div>
          até
          <div class="col-4">
            <input v-model="busca.data_final"
                   v-validate="`required`"
                   type="date"
                   name="data_final"
                   :class="{ 'is-invalid': errors.has('data_final') }"
                   class="form-control form-control-sm">
            <small v-if="errors.has('data_final')"
                   class="text-danger">{{ errors.first('data_final') }}</small>
          </div>
          <div class="col-1">
            <b-button size="sm"
                      variant="outline-primary"
                      @click="getRelatorio">
              Filtrar
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <hr>
    <div class="row">
      <div class="col text-right">
        <b-button size="sm"
                  :disabled="!busca.data_inicial || !busca.data_final"
                  @click="showModalImprimir()">
          <icon-svg icon="print"
                    class="icon--xs icons--white" />
          Imprimir
        </b-button>
        <b-button size="sm"
                  :disabled="!busca.data_inicial || !busca.data_final"
                  class="ml-3"
                  @click="showModalExportar()">
          <icon-svg icon="fileDownload"
                    class="icon--xs icons--white" />
          Exportar
        </b-button>
      </div>
    </div>

    <!-- Listagem -->
    <div v-if="relatorio != null">
      <div v-for="(vigencia, index) in vigencias"
           :key="index">
        <div class="mt-3 Divisor">
          Ref. Tabela de Custas: {{ vigencia | date }}
        </div>

        <!-- Registro Civil -->
        <div v-if="!!relatorio.vigenciaRelatorios[vigencia]"
             class="row ListagemHeader mt-1 p-2 pl-0 mr-0 ml-0">
          <div class="col-8">
            Atos de Registro Civil
          </div>
          <div class="col-2 d-flex justify-content-center">
            Qtde. Atos
          </div>
          <div class="col-2 d-flex justify-content-end">
            Valor Total
          </div>
        </div>

        <div class="ListagemRelatorio">
          <div v-for="(item, index) in relatorio.vigenciaRelatorios[vigencia]"
               :key="index">
            <ServicosRecolhimentosRCToggle :prop-relatorio="item"
                                           :prop-periodo-inicial="periodo_inicial"
                                           :prop-periodo-final="periodo_final" />
          </div>
        </div>

        <!-- Atos Notariais -->
        <div v-if="!!relatorio.vigenciaRelatoriosNotas[vigencia]"
             class="row ListagemHeader mt-1 p-2 pl-0 mr-0 ml-0">
          <div class="col-8">
            Atos de Notas
          </div>
          <div class="col-2 d-flex justify-content-center">
            Qtde. Atos
          </div>
          <div class="col-2 d-flex justify-content-end">
            Valor Total
          </div>
        </div>

        <div class="ListagemRelatorio">
          <div v-for="(item, index) in relatorio.vigenciaRelatoriosNotas[vigencia]"
               :key="index">
            <ServicosRecolhimentosNotasToggle :prop-relatorio="item"
                                              :prop-periodo-inicial="periodo_inicial"
                                              :prop-periodo-final="periodo_final" />
          </div>
        </div>
      </div>

      <div class="row DivisorTotal mt-1 p-2 pl-0 mr-0 ml-0">
        <div class="col-8">
          Total
        </div>
        <div class="col-2 d-flex justify-content-center">
          {{ relatorio.total_qtd + relatorio.total_qtd_notas }}
        </div>
        <div class="col-2 d-flex justify-content-end">
          {{ totalSetor.toLocaleString('pt-br', {minimumFractionDigits: 2}) }}
        </div>
      </div>
    </div>

    <b-modal id="modal-impressao"
            ref="modal-impressao"
            centered
            size="lg"
            hide-footer
            title="Impressão de relatórios">

      <div class="row">
        <div class="col-6 mb-3">
          <b-button size="md"
                    block
                    variant="outline-primary"
                    @click="getPdf('tipoAtos')">
            Completo - por tipo de registro
          </b-button>
        </div>

        <div class="col-6 mb-3">
          <b-button size="md"
                    block
                    variant="outline-primary"
                    @click="getPdf('detalhadoOs')">
            Completo - detalhado por OS
          </b-button>
        </div>

        <div class="col-6 mb-3">
          <b-button size="md"
                    block
                    variant="outline-primary"
                    @click="getPdf('detalhadoOsSemAgrupamento')">
            Completo - agrupado por OS
          </b-button>
        </div>

        <div class="col-6 mb-3">
          <b-button size="md"
                    block
                    variant="outline-primary"
                    @click="getPdf('resumidoTjsp')">
            Resumido - Versão TJSP
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal id="modal-exportar"
            ref="modal-exportar"
            centered
            size="lg"
            hide-footer
            title="Exportar relatórios">

      <div class="row">
        <div class="col-6 mb-3">
          <b-button size="md"
                    block
                    variant="outline-primary"
                    @click="exportPDF('tipoAtos', 'por tipo de registro')">
            Completo - por tipo de registro
          </b-button>
        </div>

        <div class="col-6 mb-3">
          <b-button size="md"
                    block
                    variant="outline-primary"
                    @click="exportPDF('detalhadoOs', 'detalhado por OS')">
            Completo - detalhado por OS
          </b-button>
        </div>

        <div class="col-6 mb-3">
          <b-button size="md"
                    block
                    variant="outline-primary"
                    @click="exportPDF('detalhadoOsSemAgrupamento', 'agrupado por OS')">
            Completo - agrupado por OS
          </b-button>
        </div>

        <div class="col-6 mb-3">
          <b-button size="md"
                    block
                    variant="outline-primary"
                    @click="exportPDF('resumidoTjsp', 'TJSP')">
            Resumido - Versão TJSP
          </b-button>
        </div>
      </div>

    </b-modal>


    <!-- <div class="row mt-3">
      <div class="col">
        <object v-if="urlPdf != null"
                class="document-preview embed-responsive Relatorios--pdf"
                :data="urlPdf"
                type="application/pdf">
          <p>Seu browser não suporta arquivos pdf diretamente ou este arquivo não existe. Você pode tentar efetuar o download clicando.</p>
        </object>
      </div>
    </div> -->
  </div>
</template>

<script>
  /* components */
  import HeaderBlue from "@/components/SofiaRei/Headers/HeaderBlue"
  import ServicosRecolhimentosRCToggle from "@/components/SofiaRei/Relatorios/ServicosRecolhimentoRCToggle"
  import ServicosRecolhimentosNotasToggle from "@/components/SofiaRei/Relatorios/ServicosRecolhimentoNotasToggle"

  /* services */
  import RelatorioCustaService from "@/services/Relatorios/RelatorioCustaService"
  import CartorioService from "@/services/CartorioService"

  /* others */
  import { mapGetters } from "vuex"
  import moment from 'moment'

  export default {
    name: "Relatorios",
    components: {
      HeaderBlue,
      ServicosRecolhimentosRCToggle,
      ServicosRecolhimentosNotasToggle
    },
    data () {
      return {
        busca: {
          filtro: 'diario',
          tipo: 'detalhado',
          cartorio_id: this.$store.state.auth.cartorio_id,
          data_inicial: null,
          data_final: null
        },
        urlPdf: null,
        cartorio: {},
        relatorio: null,
        vigencias: [],
        periodo_inicial: null,
        periodo_final: null,
        totalSetor: ''
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
      }),
    },
    async created () {
      const { data } = await CartorioService.getCartorioRei(this.$store.state.auth.cartorio_id)
      this.cartorio = data
    },
    methods: {
      getRelatorio () {
        this.$validator.validate().then(async resp => {
          if (resp) {
            try {
              loader({ text: 'Carregando Informações...', active: true })
              this.relatorio = null

              const relatorio = await RelatorioCustaService.getItensRelatorio({ ...this.busca, cartorio: this.cartorio })
              this.relatorio = relatorio

              this.periodo_inicial = this.busca.data_inicial
              this.periodo_final = this.busca.data_final

              if (this.relatorio) {
                this.tratarVigencias(this.relatorio)
                const valor = (this.relatorio.valor_total + this.relatorio.valor_total_notas)
                this.totalSetor = this.realToCents(valor)
              }
            } catch (e) {
              console.error(e)
            } finally {
              loader({ active: false })
            }
          }
        })
      },
      getPdf (tipoRelatorio) {
        this.$validator.validate().then(async resp => {
          if (resp) {
            try {
              loader({ text: 'Gerando Relatório...', active: true })

              this.urlPdf = await RelatorioCustaService.getPdfRelatorio({ ...this.busca, cartorio: this.cartorio, reportSelect: tipoRelatorio })
              window.open(this.urlPdf)
            } catch (e) {
              console.error(e)
              displayMessage('Erro ao gerar relatório: ' + e.response.data.message)
            } finally {
              this.$refs["modal-impressao"].hide()
              loader({ active: false })
            }
          }
        })
      },
      realToCents (real) {
        if (!real) return

        return (real / 100).toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        })

      },
      async exportPDF (tipoRelatorio, description) {
        this.$validator.validate().then(async resp => {
          if (resp) {
            loader({text: 'Exportando em excel', active: true})
            try {
              moment.locale('pt-br')

              const resExcel = await RelatorioCustaService.exportExcelRelatorio({...this.busca, cartorio: this.cartorio, reportSelect: tipoRelatorio})

              const blob = new Blob([resExcel.data], {type: resExcel.headers['content-type']})
              const link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.setAttribute('download', `Serviços realizados e recolhidos ${description} - ` + moment(new Date()).format('LL') + '.xlsx')
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
            } catch (e) {
              console.error(e)
              displayMessage('Erro ao exportar relatório: ' + e.response.data.message)
            } finally {
              this.$refs["modal-exportar"].hide()
              loader({ active: false })
            }
          }
        })
      },
      async tratarVigencias (relatorio) {
        this.vigencias = []
        if (!!relatorio.vigenciaRelatorios) {
          Object.keys(relatorio.vigenciaRelatorios).forEach(key => {
            this.vigencias.push(key)
          })
        }

        if (!!relatorio.vigenciaRelatoriosNotas) {
          Object.keys(relatorio.vigenciaRelatoriosNotas).forEach(key => {
            this.vigencias.push(key)
          })
        }
        
        // Removemos vigencias duplicadas: 
        this.vigencias = this.vigencias.filter((valor, indice, self) => {
          return self.indexOf(valor) === indice
        })
      },
      showModalExportar (tipo) {
        this.$refs["modal-exportar"].show()
      },
      showModalImprimir (tipo) {
        this.$refs["modal-impressao"].show()
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../../../scss/_utilities/_exports';
  .Relatorios {
    &--pdf {
      height: 50vh;
    }
  }
  .Divisor {
      background-color: #eaeaea;
      color: $color-dark;
      font-size: pxToRem(16);
      font-weight: 500;
      padding: pxToRem(10) pxToRem(20);
    }
  .ListagemHeader {
    background: #01bfa5;
    color: #000;
    font-size: 16px;
    font-weight: bold;
    border-radius: 3px 0px;
  }

  .ListagemRelatorio {
    border: 1px solid #696969;
    border-radius: 3px;
    border-bottom: none;
    overflow-x: auto;
  }

  .DivisorTotal {
    background-color: #d7d7d7;
    color: $color-dark;
    font-size: pxToRem(16);
    font-weight: 500;
    padding: pxToRem(10) pxToRem(20);
    margin-top: 25px !important;
    border: 1px solid;
  }

  .btn {
    white-space: nowrap !important;
  }
</style>
